export default __webpack_public_path__ + "assets/icons/edit.02c33b45.svg";